<div class="filter-panel">
    <button
        class="filter-panel_item -common-button"
        (click)="testNoWalletAuth()">
        Test w/o wallet
    </button>
    <button
        class="filter-panel_item -common-button"
        (click)="testPosFrames()">
        Pos Frames
    </button>
    <button
        class="filter-panel_item -common-button"
        (click)="testDynClient()">
        Test Dyn Client
    </button>
    @if ((dynRemote?.isLoggedIn$ | async)) {
        <button
            class="filter-panel_item -common-button"
            (click)="test()">
            Test
        </button>
        <button
            class="filter-panel_item -common-button"
            (click)="onTransfer()">
            Transfer
        </button>
    }
</div>
<partial-loading-indicator class="dex-dyn-w_loading-indicator" #loadingIndicator>

    <dyn-auth-widget-body></dyn-auth-widget-body>

</partial-loading-indicator>
